<script setup>
import {computed, onMounted, nextTick} from 'vue'
import {useUserStore} from '@/stores/user'

const props = defineProps({
    options: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['hide-modal'])

// Pinia Store
const userStore = useUserStore()

// --- Computed Properties ---
const theme = computed(() => {
    return userStore.pref('codeMirror_theme')
})

const lineNumbers = computed(() => {
    return userStore.pref('codeMirror_lineNumbers')
})

const lineWrapping = computed(() => {
    return userStore.pref('codeMirror_lineWrapping')
})

// --- Initialization & Mounting ---
onMounted(() => {
    const editorOptions = {
        mode: props.options.mode,
        lineNumbers: true,
        // Line wrapping must be enabled when presenting CodeMirror in a form else long lines will
        // stretch the form beyond the viewport.
        lineWrapping: true,
        readOnly: true,
        indentUnit: 4,
        tabMode: 'spaces',
        enterMode: 'indent',
        electricChars: false // Prevents '{' from resetting the indent
    }

    if (theme.value) {
        editorOptions['theme'] = theme.value
    }

    if (lineNumbers.value !== undefined) {
        editorOptions['lineNumbers'] = lineNumbers.value
    }

    if (lineWrapping.value !== undefined) {
        editorOptions['lineWrapping'] = lineWrapping.value
    }

    nextTick(() => {
        if (typeof CodeMirror !== 'undefined') {
            CodeMirror.fromTextArea(document.getElementById('HistoryCodeEditorModalEditor'), editorOptions)
        }
    })
})
</script>

<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ options.label }}</h4>

                <button type="button" class="btn-close" @click="emit('hide-modal')" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <textarea id="HistoryCodeEditorModalEditor">{{ options.value }}</textarea>
            </div>

            <div class="modal-footer"></div>
        </div>
    </div>
</template>